import { ASSOCIATION } from 'automation-ui-action-features/object-type-properties/TargetPropertySourceTypes';
export const getIsAssociation = ({
  metadata
}) => {
  const targetSource = metadata.getTargetSource();
  return targetSource === ASSOCIATION;
};